export default __webpack_public_path__ + "static/media/grafiken_memory_250x250_M4_01.04f5b88b.png";